import { useEffect, useState } from "react";
import Sidebar from "../AdminComp/Sidebar";
import BreadCrumb from "../AdminComp/BreadCrumb";
import { Eye } from "react-feather";
import { baseurl } from "../../../component/Baseurl";
import axios from "axios";
import AdminBookingNavbar from "./AdminBookingNavbar";

function AdminStateHeadReport() {
  const [stateHeadData, setStateHeadData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  // Fetch state heads from API
  const fetchStateHeads = async () => {
    try {
      const response = await axios.get(`${baseurl}/getAllStateHead`);
      console.log("API Response:", response.data);

      if (response.data.statehead) {
        setStateHeadData(response.data.statehead);
      } else {
        setStateHeadData([]);
      }
    } catch (error) {
      console.error("Error fetching state heads:", error);
      setError("Failed to load state heads.");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchStateHeads();
  }, []);

  return (
    <>
      <div className="App" style={{ display: "flex" }}>
        <Sidebar />

        {/* Content area */}
        <div className="content" style={{ flexGrow: 1, padding: "20px" }}>
          <div>
            <BreadCrumb />
            <div className="container-fluid">
              <AdminBookingNavbar />

              <div className="crdmain mb-2">
                <div className="d-flex justify-content-between align-items-center" style={{ width: "100%" }}>
                  <h2 className="chart-title mb-0">State Head Report</h2>
                </div>

                {/* Show loading or error */}
                {loading && <p>Loading state heads...</p>}
                {error && <p className="text-danger">{error}</p>}

                {!loading && !error && (
                  <div className="row g-2 mt-0 mb-0">
                    <div className="col-md-12 p-2">
                      {/* Table */}
                      <div className="table-responsive classic-table">
                        <table className="table table-striped table-hover">
                          <thead className="table-header">
                            <tr>
                              <th>#</th>
                              <th>Distributor ID</th>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Phone</th>
                              <th>City</th>
                              <th>State</th>
                              <th>Country</th>
                              <th>Business Name</th>
                              <th>Status</th>
                              <th>Cost per Pin</th>
                              <th>Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            {stateHeadData.length > 0 ? (
                              stateHeadData.map((stateHead, index) => (
                                <tr key={stateHead.id}>
                                  <td>{index + 1}</td>
                                  <td>{stateHead.distributor_unique_id}</td>
                                  <td>{stateHead.name}</td>
                                  <td>{stateHead.email}</td>
                                  <td>{stateHead.phone}</td>
                                  <td>{stateHead.city}</td>
                                  <td>{stateHead.state}</td>
                                  <td>{stateHead.country}</td>
                                  <td>{stateHead.business_name || "N/A"}</td>
                                  <td>
                                    <span className={`badge 
                                      ${stateHead.distributor_status === "active" ? "bg-success" : "bg-danger"}
                                    `}>
                                      {stateHead.distributor_status || "N/A"}
                                    </span>
                                  </td>
                                  <td>&#8377;{stateHead.cost_per_pin ? `${stateHead.cost_per_pin}` : "0"}</td>
                                  <td>
                                    <span className="btn2 me-2" title="View Details">
                                      <Eye size={15} />
                                    </span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan="12" className="text-center">
                                  No state heads found.
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                      </div>
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default AdminStateHeadReport;
